import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  Button,
  Table,
  Form,
  Input,
  InputNumber,
  Modal,
  message,
  Select,
  DatePicker,
} from "antd";
import RenderTxt from "@components/renderTxt";
import SystemApi from "@api/sys";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import SearchForm from "@components/SearchForm";
import moment from "moment";

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};
const Supplier = ({ userInfo }) => {
  let stationId = "-1";
  if (userInfo.stationIds) {
    userInfo.stationIds.includes(",")
      ? (stationId = userInfo.stationIds.split(",")[0])
      : (stationId = userInfo.stationIds);
  }
  const [form] = Form.useForm();
  const [visible, setVisible] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [editId, setEditId] = useState();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
  });
  const [tableSource, setTableSource] = useState({});
  const [cateList, setCateList] = useState([]);
  const [inputList] = useState([
    {
      label: "名称:",
      name: "name",
      message: "请输入名称",
      span: 6,
      labelCol: 6,
    },
    {
      label: "供应商编码:",
      name: "snNo",
      message: "请输入供应商编码",
      span: 6,
      labelCol: 6,
    },
  ]);
  const [selectList, setSelectList] = useState([
    {
      attr: { allowClear: true },
      label: "供应商类别:",
      name: "classifyId",
      message: "请选择供应商类别",
      options: [],
      span: 6,
      labelCol: 6,
    },
  ]);
  const [dateSearch] = useState([
    {
      label: "建档时间:",
      name: "recordTime",
      message: "请选择建档时间",
      span: 6,
      labelCol: 6,
      tag: "rangePicker",
    },
  ]);

  const columns = [
    {
      title: "名称",
      dataIndex: "name",
      align: "center",
      key: "name",
      render: (text) => RenderTxt(text),
    },
    {
      title: "供应商类别",
      dataIndex: "classifyName",
      align: "center",
      key: "classifyName",
      render: (text) => RenderTxt(text),
    },
    {
      title: "联系人",
      dataIndex: "contactName",
      align: "center",
      key: "contactName",
      render: (text) => RenderTxt(text),
    },
    {
      title: "联系电话",
      dataIndex: "contactPhone",
      align: "center",
      key: "contactPhone",
      render: (text) => RenderTxt(text),
    },
    {
      title: "营业执照号码",
      dataIndex: "licenseNo",
      align: "center",
      key: "licenseNo",
      render: (text) => RenderTxt(text),
    },
    {
      title: "供应商编码",
      dataIndex: "snNo",
      align: "center",
      key: "snNo",
      render: (text) => RenderTxt(text),
    },
    {
      title: "建档时间",
      dataIndex: "recordTime",
      align: "center",
      key: "recordTime",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "创建时间",
      dataIndex: "createAt",
      align: "center",
      key: "createAt",
      render: (text) => moment(text).format("YYYY-MM-DD HH:mm:ss"),
    },
    {
      title: "操作",
      dataIndex: "action",
      align: "center",
      key: "action",
      render: (text, obj) => {
        return (
          <>
            <Button type="primary" onClick={() => editRecord(obj)}>
              编辑
            </Button>
            <Button
              style={{ marginLeft: 8 }}
              type="primary"
              onClick={() => delRecord(obj.id)}
              danger
            >
              删除
            </Button>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    getCateAll();
  }, []);

  useEffect(() => {
    getListPages();
  }, [searchParams]);

  const addRecord = () => {
    setVisible(true);
  };

  const getCateAll = () => {
    SystemApi.supplierClassifyAll().then((res) => {
      if (res.status !== "0") return;
      const idx = selectList.findIndex((item) => item.name == "classifyId");
      selectList[idx].options = res.data.map((item) => {
        return {
          title: item.name,
          value: item.id,
        };
      });
      setSelectList([...selectList]);
      setCateList(res.data);
    });
  };

  const getListPages = () => {
    setLoading(true);
    SystemApi.supplierList(searchParams).then((res) => {
      setLoading(false);
      if (res.status !== "0") return;
      const { data } = res.data;
      data.map((item) => {
        item.key = item.id;
      });
      setTableSource(res.data);
    });
  };

  const delRecord = (id) => {
    Modal.confirm({
      onOk: () => {
        SystemApi.supplierRemove({ id }).then((res) => {
          if (res.status !== "0") return;
          message.success("删除成功");
          getListPages();
        });
      },
      title: "请确认",
      icon: <ExclamationCircleOutlined />,
      content: "是否删除",
      okText: "确认",
      cancelText: "取消",
    });
  };

  const editRecord = (obj) => {
    setVisible(true);
    setEditId(obj.id);
    form.setFieldsValue({ ...obj, recordTimeStr: moment(obj.recordTime) });
  };

  const cancel = () => {
    setVisible(false);
    form.resetFields();
    setEditId(null);
  };

  const save = () => {
    form.validateFields().then((values) => {
      const params = {
        stationId,
        ...values,
        recordTimeStr: values.recordTimeStr.format("YYYY-MM-DD HH:mm:ss"),
      };
      if (editId) {
        setConfirmLoading(true);
        SystemApi.supplierUpdate({ ...params, id: editId }).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("修改成功");
          cancel();
          getListPages();
        });
      } else {
        setConfirmLoading(true);
        SystemApi.supplierSave(params).then((res) => {
          setConfirmLoading(false);
          if (res.status !== "0") return;
          message.success("新增成功");
          cancel();
          getListPages();
        });
      }
    });
  };

  const handleTableChange = (pagination) => {
    const params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    };
    setSearchParams(params);
  };

  const search = (values) => {
    const params = {
      ...values,
      pageNum: 1,
      pageSize: 10,
      startTime: values.recordTime
        ? values.recordTime[0].format("YYYY-MM-DD") + " 00:00:00"
        : undefined,
      endTime: values.recordTime
        ? values.recordTime[1].format("YYYY-MM-DD") + " 23:59:59"
        : undefined,
    };
    params.recordTime && delete params.recordTime;
    setSearchParams(params);
  };

  return (
    <div style={{ padding: 20 }}>
      <SearchForm
        span={6}
        inputList={inputList}
        selectList={selectList}
        dateSearch={dateSearch}
        onSearch={search}
      />
      <Button
        type="primary"
        style={{ marginBottom: "10px" }}
        onClick={addRecord}
      >
        新增
      </Button>
      <Table
        loading={loading}
        columns={columns}
        dataSource={tableSource.data}
        pagination={{
          current: tableSource.pageNum,
          pageSize: tableSource.pageSize,
          showQuickJumper: true,
          showSizeChanger: true,
          showTotal: (total) => `共${total}条数据`,
          total: tableSource.total * 1,
        }}
        onChange={handleTableChange}
      />
      {visible && (
        <Modal
          title={editId ? "编辑" : "新增"}
          open={visible}
          onCancel={cancel}
          onOk={save}
          confirmLoading={confirmLoading}
        >
          <Form {...layout} form={form}>
            <Form.Item
              label="名称"
              name="name"
              rules={[{ required: true, message: "请输入名称!" }]}
            >
              <Input placeholder="请输入名称" />
            </Form.Item>
            <Form.Item
              label="供应商类别"
              name="classifyId"
              rules={[{ required: true, message: "请选择供应商类别!" }]}
            >
              <Select placeholder="请选择供应商类别">
                {cateList.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="联系人"
              name="contactName"
              rules={[{ required: true, message: "请输入联系人!" }]}
            >
              <Input placeholder="请输入联系人" />
            </Form.Item>
            <Form.Item
              label="联系电话"
              name="contactPhone"
              rules={[{ required: true, message: "请输入联系电话!" }]}
            >
              <InputNumber
                style={{ width: "100%" }}
                placeholder="请输入联系电话"
              />
            </Form.Item>
            <Form.Item
              label="营业执照号码"
              name="licenseNo"
              rules={[{ required: true, message: "请输入营业执照号码!" }]}
            >
              <Input placeholder="请输入营业执照号码" />
            </Form.Item>
            <Form.Item
              label="供应商编码"
              name="snNo"
              rules={[{ required: true, message: "请输入供应商编码!" }]}
            >
              <Input placeholder="请输入供应商编码" />
            </Form.Item>
            <Form.Item
              label="建档时间"
              name="recordTimeStr"
              rules={[{ required: true, message: "请选择建档时间!" }]}
            >
              <DatePicker />
            </Form.Item>
            {editId && (
              <Form.Item
                label="是否启用"
                name="status"
                rules={[{ required: true, message: "请选择是否启用!" }]}
              >
                <Select placeholder="请选择是否启用">
                  <Select.Option value={true}>是</Select.Option>
                  <Select.Option value={false}>否</Select.Option>
                </Select>
              </Form.Item>
            )}
          </Form>
        </Modal>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Supplier);
